import React from "react"
import ScrollToHash from "components/layouts/ScrollToHash";
import Home from 'components/pages/Home'
import NewsIndex from 'components/pages/NewsIndex'
import NewsDetail from 'components/pages/NewsDetail'
import Rulebook from 'components/pages/Rulebook'
import Guideline from 'components/pages/Guideline'
import StaffWanted from 'components/pages/StaffWanted'
import Credit from 'components/pages/Credit'
import NotFound from 'components/pages/NotFound'
import CommonLayout from "components/layouts/CommonLayout"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async";

const App: React.FC = () => {
  return (
    <>
      <HelmetProvider>
        <Router>
          <ScrollToHash />
          <CommonLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<NewsIndex />} />
              <Route path="/news/:urlHash" element={<NewsDetail />} />
              {/* <Route path="/rulebook" element={<Rulebook />} /> */}
              <Route path="/guideline" element={<Guideline />} />
              <Route path="/staff-wanted" element={<StaffWanted />} />
              <Route path="/credit" element={<Credit />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </CommonLayout>
        </Router>
      </HelmetProvider>
    </>
  )
}

export default App
